import { Pipe, PipeTransform } from '@angular/core';
import { Title } from '@angular/platform-browser';


@Pipe({
    name: 'docName'
})

export class DocNamePipe implements PipeTransform {

    constructor(
    ) { }

    transform(user: {
       
        "title"?: Title | null;
        "firstname"?: string;
        "lastname"?: string;
    }): string {
        if (user) {
            let name = user.firstname + ' ' + user.lastname;
            if (user.title) {
                return user.title + ' ' + name;
            }
            
        }
        return 'invalid_name';
    }

    
}